import React from "react"
import PropTypes from "prop-types"

const InfoCircleIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 20 20">
    <path fill="currentColor" fillRule="evenodd" d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.348-11.59a1.02 1.02 0 0 0-1.03 1.008c0 .574.466 1.037 1.03 1.037a1.03 1.03 0 0 0 1.016-1.023 1.02 1.02 0 0 0-1.016-1.023zm1.688 7.296c.05-.162-.1-.265-.3-.206-.116.03-.216.103-.333.147-.15.06-.3.104-.45.118-.183.015-.316-.073-.366-.236-.033-.117-.05-.25-.033-.368.033-.25.1-.501.15-.752.15-.766.316-1.518.466-2.285.05-.206.083-.413.083-.62 0-.25-.166-.368-.45-.368H6.007c-.1 0-.2 0-.283.015-.166.03-.25.103-.266.221-.017.103.066.221.216.266.133.03.266.044.4.059.316.029.416.132.416.412 0 .045-.017.089-.017.133-.133.663-.266 1.342-.4 2.005l-.2 1.15c-.082.56.534 1.09 1.017 1.15.3.044.582.044.882.044.633 0 1.165-.236 1.598-.634a.693.693 0 0 0 .167-.25z" />
  </svg>
)

InfoCircleIcon.propTypes = {
  style: PropTypes.object
}

export default InfoCircleIcon



// WEBPACK FOOTER //
// ./src/components/icons/info-circle-icon.jsx